import { ref } from 'vue';

export function useNotifications() {
  const notification = ref({
    show: false,
    message: '',
    type: 'info',
  });

  function showNotification(message, type = 'info', duration = 4000) {
    notification.value = {
      show: true,
      message,
      type,
    };

    if (duration > 0) {
      setTimeout(() => {
        hideNotification();
      }, duration);
    }
  }

  function hideNotification() {
    notification.value.show = false;
    setTimeout(() => {
      notification.value.message = '';
      notification.value.type = 'info';
    }, 300);
  }

  return {
    notification,
    showNotification,
    hideNotification,
  };
}
